import React from 'react';
import { WavesIcon } from 'lucide-react';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_PRICE } from '../data/config';
import { trackPixel } from '../utils/pixel';
type CtaButtonProps = {
  children: React.ReactNode;
  mode: 'checkout' | 'scroll';
  subtext?: string;
  className?: string;
};
export function CtaButton({
  children,
  mode,
  subtext,
  className = 'max-w-[448px]'
}: CtaButtonProps) {
  const isCheckout = mode === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={() => isCheckout && trackPixel('InitiateCheckout', {
    value: PRODUCT_PRICE,
    currency: 'USD'
  })} className={`mx-auto flex min-h-[50px] w-full flex-col items-center justify-center rounded-md bg-gold px-4 py-2.5 text-center text-navy shadow-cta transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-goldHover active:translate-y-[2px] active:shadow-cta-pressed focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${className}`} data-id="element-34" data-mp="qih7dite85i7">
      <span className="flex items-center gap-2 font-heading text-[16px] font-extrabold uppercase leading-tight md:text-[19px]" data-id="element-35" data-mp="35xxu6v8t2xve">
        <WavesIcon className="h-[18px] w-[18px] shrink-0" strokeWidth={2.75} aria-hidden data-id="element-36" data-mp="39z9imxfy1d20" />
        {children}
      </span>
      {subtext && <span className="mt-1 text-[11px] font-semibold leading-tight" data-id="element-37" data-mp="3jwxg3v4xoynv">{subtext}</span>}
    </a>;
}